import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from "vue";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'OKDialog',
  setup(__props) {

const store = useStore();
const displayDialog = ref(false);
let dialog: any = ref({});

dialog = computed(() => store.getters["application/getDialog"]);

watch(dialog, (currentValue, oldValue) => {
  displayDialog.value = currentValue.title !== "";
});

const closeDialog = () => {
  store.dispatch("application/clearDialog");
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _unref(dialog) ? _unref(dialog).title : '',
    dismissableMask: true,
    modal: true,
    visible: displayDialog.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((displayDialog).value = $event)),
    style: { width: '25vw' }
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "OK",
        icon: "pi pi-check",
        onClick: closeDialog,
        autofocus: ""
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_unref(dialog).message), 1)
    ]),
    _: 1
  }, 8, ["header", "visible"]))
}
}

})